import React, { useEffect, useState } from "react";
import { CubeIcon } from "@heroicons/react/outline";
import { apiGet } from "helpers/Request";
import { useAuth } from "hooks/Auth";
import { transform as auditLogTransformer } from "schemas/AuditLog";
import Pagination from "components/General/Pagination";
import { getPaginationMeta } from "schemas/Util";
import { fromSqlDateTime } from "helpers/Date";

export default function AuditLog(props) {
    const [loading, setLoading] = useState(false);
    const [logs, setLogs] = useState([]);
    const [page, setPage] = useState(0);
    const auth = useAuth();
    const { content } = props;
    const [paginationMeta, setPaginationMeta] = useState({});

    useEffect(() => {
        if (!content || !content.uuid) {
            return;
        }
        apiGet(`/v4/content/${content.uuid}/audit-log`, auth.publication, {
            page: page,
            per_page: 20,
        }).then((resp) => {
            setLogs(auditLogTransformer(resp));
            setLoading(false);
            setPaginationMeta(getPaginationMeta(resp));
        });
    }, [content, page, auth.publication]);

    if (loading) {
        return (
            <div className="w-full py-10 text-center">
                <CubeIcon className="mx-auto h-8 w-8 animate-rotate-pulse text-gray-300" />
            </div>
        );
    }

    return (
        <div>
            <Pagination
                onClick={(meta) => setPage(meta.page)}
                {...paginationMeta}
            />
            <div className="w-full divide-y divide-gray-200">
                {logs.map((log) => (
                    <div key={log.id} className="py-4">
                        <div className="flex align-top">
                            <strong className="font-weight-bold text-gray-900">
                                {fromSqlDateTime(log.created_at).toFormat("ff")}
                            </strong>
                            <div className="ml-4">
                                {log.user ? log.user.name : "DELETED USER"}
                            </div>
                        </div>
                        <div className="mt-1">{log.message}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
